module.exports = __webpack_public_path__ + "static/media/D52.4ac42907.svg";